"use client"

import dynamic from "next/dynamic"
import { AppStateProvider } from "@/lib/app-state"
import { ThemeProvider } from "@/components/theme-provider"

/** Avoid Sonner × theme / matchMedia hydration mismatches (React #418 / #423). */
const Toaster = dynamic(
  () => import("sonner").then((mod) => mod.Toaster),
  { ssr: false },
)

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <AppStateProvider>
        {children}
        <Toaster richColors position="top-right" />
      </AppStateProvider>
    </ThemeProvider>
  )
}
